import { render, staticRenderFns } from "./RelationUpdated.vue?vue&type=template&id=7e957d37"
import script from "./RelationUpdated.vue?vue&type=script&lang=js"
export * from "./RelationUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports